/**
 * PHP 라우트( current_controller() / current_action() )의 short class name 과 동기화한 TS 엔트리맵.
 * ( 예: web.php App\Controllers\Community\Pichi\PichiHomeController@index → "PichiHomeController", "index" )
 */
import {
    PichiHomeController,
    IntroController,
    BrandStoryController,
    FranchiseController,
    MenuController,
    StoresController,
    EventsController,
    NoticeController,
    PressController,
    DetailController,
    ContactController,
    LegalController,
} from "../home/controllers";

import {
    AdminAnalyticsController,
    AdminAuthController,
    AdminController,
    AdminDocsLibraryController,
    AdminFeatureController,
    AdminMenuController,
    AdminPreferencesController,
    AdminProjectDocController,
    RoleController,
    UserController,
    AdminContactController,
    AdminNameMarketItemController,
    AdminSiteinfoController,
    AdminSiteMetaController,
    AdminWorkController,
    AdminWorkCategoryController,
    AdminWorkServiceController,
    AdminWorkTemplateController,
} from "../admin/controllers";

export type ControllerMap = Record<string, () => void>;

export const controllerRegistry: Record<string, ControllerMap> = {
    // admin
    AdminAnalyticsController,
    AdminAuthController,
    AdminMenuController,
    AdminController,
    AdminDocsLibraryController,
    AdminFeatureController,
    AdminPreferencesController,
    AdminProjectDocController,
    RoleController,
    UserController,
    AdminContactController,
    AdminNameMarketItemController,
    AdminSiteinfoController,
    AdminSiteMetaController,
    AdminWorkController,
    AdminWorkCategoryController,
    AdminWorkServiceController,
    AdminWorkTemplateController,
    // pichi public
    PichiHomeController,
    IntroController,
    BrandStoryController,
    FranchiseController,
    MenuController,
    StoresController,
    EventsController,
    NoticeController,
    PressController,
    DetailController,
    ContactController,
    LegalController,
};
